import React, { useEffect } from 'react';
import { Form, Input, Button, Card, Typography, Checkbox } from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import { useAuth } from '@/contexts/AuthContext';
import './Login.css';

const { Title, Text } = Typography;

interface LoginFormData {
  username: string;
  password: string;
  remember: boolean;
}

const Login: React.FC = () => {
  const [form] = Form.useForm();
  const { login, loading } = useAuth();

  // 页面加载时检查是否有记住的密码
  useEffect(() => {
    const rememberedUsername = localStorage.getItem('rememberedUsername');
    const rememberedPassword = localStorage.getItem('rememberedPassword');
    const isRemembered = localStorage.getItem('isRemembered') === 'true';
    const rememberChecked = !!rememberedPassword || isRemembered;

    // 只要已记住密码就勾选复选框；有值则回填账号密码
    const fields: Partial<LoginFormData> = {
      remember: rememberChecked,
    };

    if (rememberedUsername) {
      fields.username = rememberedUsername;
    }
    if (rememberedPassword) {
      fields.password = rememberedPassword;
    }

    form.setFieldsValue(fields);
  }, [form]);

  const handleLogin = async (values: LoginFormData) => {
    const success = await login(values.username, values.password);
    
    if (success) {
      // 处理记住密码 - 简化逻辑
      if (values.remember) {
        localStorage.setItem('rememberedUsername', values.username);
        localStorage.setItem('rememberedPassword', values.password);
        localStorage.setItem('isRemembered', 'true');
      } else {
        // 不勾选就清除记住的密码
        localStorage.removeItem('rememberedUsername');
        localStorage.removeItem('rememberedPassword');
        localStorage.removeItem('isRemembered');
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-particles"></div>
      </div>
      
      <div className="login-content">
        <Card className="login-card">
          <div className="login-header">
            <div className="login-logo">
              <div className="logo-icon">OTT</div>
              <Title level={2} className="login-title">
                OTA管理平台
              </Title>
            </div>
            <Text className="login-subtitle">
              设备升级管理系统
            </Text>
          </div>

          <Form
            form={form}
            name="login"
            onFinish={handleLogin}
            layout="vertical"
            size="large"
            className="login-form"
          >
            <Form.Item
              name="username"
              label="用户名"
              rules={[
                { required: true, message: '请输入用户名' },
                { min: 3, message: '用户名至少3个字符' }
              ]}
            >
              <Input
                prefix={<UserOutlined className="input-icon" />}
                placeholder="请输入用户名"
              />
            </Form.Item>

            <Form.Item
              name="password"
              label="密码"
              rules={[
                { required: true, message: '请输入密码' },
                { min: 6, message: '密码至少6个字符' }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="input-icon" />}
                placeholder="请输入密码"
              />
            </Form.Item>

            <Form.Item name="remember" valuePropName="checked" className="login-remember">
              <Checkbox className="login-remember-checkbox">
                记住密码
              </Checkbox>
            </Form.Item>

            <Form.Item className="login-actions">
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="login-button"
                icon={<LoginOutlined />}
                block
              >
                {loading ? '登录中...' : '登录'}
              </Button>
            </Form.Item>
          </Form>

          {/* <div className="login-footer">
            <Text className="login-tip">
              默认账号：admin / admin123
            </Text>
          </div> */}
        </Card>
      </div>
    </div>
  );
};

export default Login;
